<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>儲能-Careers</h2>
            <h2 style="padding-top: 10px;">加入我們</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Details Area -->
<section class="services-details-area ptb-100" style="padding-bottom: 0px;">
    <div class="container" style="max-width: 80%;">
        <div class="services-details-overview" style="justify-content: space-evenly;align-items: center; padding-top: 15px;">

            <div class="services-details-desc" style="padding-top: 15px;">
                <h3 style="color: #2781bd;">You are matter to us</h3>
                <p>“真正的發現之旅不在於尋找新大陸，而是以新的眼光去看事物”by 普魯斯特 Marcel Proust；如果你相信未來掌握在自己手裡，不害怕失敗與挫折，擁有熱情探索與不懈學習的靈魂，希望能夠挑戰自己，激發潛能，歡迎加入<span>碩達系統</span>! 對於碩達，每一個人都是獨特且獨立的存在，因為匯集不同的聲音才能協奏出美妙的樂章，我們欣賞您的不同，也期望您能在這裡發揮最大的價值，創造不凡。<br>我們團隊平均年齡30+歲，但是橫跨老中青三代，彙整不同觀點，鼓勵思考與創新。我們熱愛揪團，不只是買東西還有運動。我們的企業文化就是誠實與自律，如果您也認同，歡迎您的加入！</p>
            </div>
            <img src="assets/img/join-us/加入我們_pic_17_ss.png" alt="image" class="solution-details-pic">
        </div>

        <div class="services-details-overview" style="justify-content: space-evenly;align-items: center; padding-top: 15px;">

            <img src="assets/img/join-us/加入我們_pic_19.png" alt="image" class="solution-details-pic">
            <div class="services-details-desc" style="padding-top: 15px;">
                <h3 style="color: #2781bd;">公司福利</h3>
                <p>從自我專業提升到身心靈管理，我們全都在乎<br><br>1. 每週上班五天(固定週休二日)<br>2. 採人性化管理 ，彈性上下班時間<br>3. 享勞保、健保、勞退提撥<br>4. 視個人績效表現發放年終獎金、績效獎金等優渥獎勵<br>5. 舉辦年終尾牙活動與各項團體活動<br>6. 安排與補助各類教育訓練課程(內訓/外訓)<br>7. 不定期舉辦各類講座及活動<br>提供多元化的學習管道，包含不定期舉辦各種講座及活動、外派訓練，以及在職訓練，提供各類學習方式，自我成長。<br>8.
                    提供領先業界的自主假
                    <br>照護員工生活無後顧之憂，於特休假用罄後，仍然有請假之需求時，可申請自主假，安心處理生活所需。</p>
            </div>
        </div>
    </div>
</section>
<!-- End Features Area -->

<app-subscribe></app-subscribe>